import styles from './RadioButton.module.css';

type RadioButtonType = {
  id?: string;
  name?: string;
  value?: string;
  onChange: () => void;
  checked: boolean;
  text?: string;
  required?: boolean;
};

export default function RadioButton({ name, id, value, onChange, checked, text, required = false }: RadioButtonType) {
  return (
    <label htmlFor={id} className={styles.radioLabel}>
      <input
        className={styles.radioInput}
        type="radio"
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        checked={checked}
        required={required}
      />
      <span style={{ fontSize: '14px' }}>{text}</span>
    </label>
  );
}
